import { createMultiStyleConfigHelpers as d } from "@chakra-ui/react";
import { ThemeSpaceVariable as t } from "../../theme-types.js";
import { ThemeBorderToken as a, ThemeRadiusToken as i, ThemeFontToken as l, ThemeColorToken as e, ThemeFontSizeToken as r } from "../theme-tokens.js";
import { tabsAnatomy as c } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: o, defineMultiStyleConfig: g } = d(c.keys), s = o({
  tab: {
    color: e.OnBackground,
    fontFamily: l.SubHeader,
    fontWeight: "medium",
    borderRadius: i.XLarge,
    bg: "none",
    border: a.XSmall,
    borderColor: "transparent",
    whiteSpace: "nowrap",
    WebkitTapHighlightColor: "transparent"
  },
  tabWithImage: {
    _disabled: {
      cursor: "not-allowed"
    }
  },
  tabpanel: {
    p: 0
  }
}), b = {
  sm: o({
    tab: {
      fontSize: r.Large,
      lineHeight: "160%",
      height: "40px"
    }
  }),
  md: o({
    tab: {
      fontSize: r.XLarge,
      lineHeight: "125%",
      height: "48px"
    }
  })
}, n = {
  _disabled: {
    _selected: {
      bg: e.AccentContainer,
      color: e.OnAccentContainer
    },
    bg: "transparent",
    color: e.OnBackground
  },
  bg: e.AccentContainer,
  color: e.OnAccentContainer
}, m = {
  default: o({
    tab: {
      "@media(hover: hover)": {
        _hover: n,
        _groupHover: n
      },
      _selected: n,
      _disabled: { opacity: 0.48 }
    }
  }),
  line: o({
    tab: {
      bg: "none",
      border: a.None,
      borderRadius: i.None,
      borderBottom: "0px solid",
      paddingLeft: t.Large,
      paddingRight: t.Large,
      paddingBottom: t.Large,
      maxWidth: "100px",
      fontSize: r.Medium,
      _selected: {
        bg: "none",
        color: e.OnBackground,
        borderBottom: "2px solid",
        _hover: {
          textDecoration: "none"
        }
      },
      _hover: {
        textDecoration: "underline"
      }
    }
  })
}, S = g({
  sizes: b,
  variants: m,
  baseStyle: s
});
export {
  S as tabsConfig
};
